/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Day from 'dayjs'

export default {
  //   subjectList: state => state.subjectCode.filter((code)=> {
  //     if(!state.gradeId) {
  //       return state.subjectCode
  //     } else {
  //       return code.grade == state.gradeId
  //     }
  //   }),
  gedStagingExamList: (state, getters, rootState) => {
    if (!state.gedExamSubjectList || !Array.isArray(state.gedExamSubjectList)) {
      return []
    }
    return state.gedExamSubjectList.filter((exam) => {
      return exam.state == 0 && (exam.ged_exam_name ? ((exam.ged_exam_name == rootState.exam.searchKeyword.text) || exam.ged_exam_name.includes(rootState.exam.searchKeyword.text)) : (rootState.exam.searchKeyword.text ? false : true)) &&
        (rootState.exam.activeGrade.length ? rootState.exam.activeGrade.includes(exam.grade_id) : true) &&
        ((rootState.exam.activeFilterSub.name != '과목별') ? (rootState.exam.activeFilterSub.subject_type_id == exam.subject_type_id) : true)
    })
  },
  gedReviewList: (state, getters, rootState) => {
    if (!state.gedExamSubjectList || !Array.isArray(state.gedExamSubjectList)) {
      return []
    }
    return state.gedExamSubjectList.filter((exam) => {
      return exam.state == 1 && (exam.ged_exam_name ? ((exam.ged_exam_name == rootState.exam.searchKeyword.text) || exam.ged_exam_name.includes(rootState.exam.searchKeyword.text)) : (rootState.exam.searchKeyword.text ? false : true)) &&
        (rootState.exam.activeGrade.length ? rootState.exam.activeGrade.includes(exam.grade_id) : true) &&
        ((rootState.exam.activeFilterSub.name != '과목별') ? (rootState.exam.activeFilterSub.subject_type_id == exam.subject_type_id) : true)
    })
  },
}
